<div class="container" [style]="{'width': width}"> 
  <!-- Search -->
  <label for="searchInputContainer" style="display:none;">Search</label> 
  <input
    aria-label="test"
    data-test-id="searchInputContainer"
    id="searchInputContainer"
    matInput 
    class="search-input" 
    [placeholder]="placeholder" 
    [(ngModel)]="searchValue"
    (ngModelChange)="onChanges($event)"
    aria-labelledby="searchInputContainer"
  />

  <!-- Reset Button -->
  <div *ngIf="searchValue.length > 0">
    <button data-test-id="searchResetActionButton" class="reset-icon" (click)="reset()">
      <mat-icon data-test-id="icon">close</mat-icon>
    </button>
  </div>

  <!-- Search Icon -->
  <div class="search-icon-container" [style.width]="searchIconWidth">
    <mat-icon data-test-id="searchIcon" class='search-icon-container__icon'>search</mat-icon>
  </div>
</div>
